import * as React from "react";
import {Controller} from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {Images} from "assets/images";

export const SelectMain = ({
                               classNameWrapper,
                               stylesWrapper,
                               control,
                               name,
                               rules,
                               placeholder,
                               list,
                               renderLabel,
                               disabled,
                               disableClearable,
                           }) => {
    return (
        <div
            className={`main-select-wrapper ${classNameWrapper ? classNameWrapper : ""}`}
            style={stylesWrapper}
        >
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={({
                             field,
                             field: {onChange, value},
                             formState: {errors},
                         }) => {
                    return (
                        <>
                            <Autocomplete
                                {...field}
                                disabled={disabled}
                                classes={{
                                    popper: 'main-select-popper-wrapper'
                                }}
                                id="checkboxes-tags-demo"
                                error={!!errors[field?.name]?.message}
                                sx={{
                                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                        borderColor: errors[field?.name]?.message
                                            ? "#D03325"
                                            : "#555768",
                                    },
                                }}
                                popupIcon={<Images.ArrowDown/>}
                                disableClearable={disableClearable}
                                options={list}
                                value={value || {value: "", label: ""}}
                                getOptionLabel={(option) => renderLabel(option)}
                                isOptionEqualToValue={(option, value) =>
                                    option?.value === value?.value
                                }
                                onChange={(event, item) => {
                                    onChange(item);
                                }}
                                renderOption={(props, option, selected) => {
                                    return (
                                        <li
                                            {...props}
                                            key={option?.value}
                                            className={`main-select-option ${
                                                option?.name === selected?.inputValue ? "main-select-option-selected" : ""
                                            }`}
                                        >
                                            {renderLabel(option)}
                                        </li>
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder={placeholder}/>
                                )}
                            />
                            <p className="error-message">{errors[field?.name]?.message}</p>
                        </>
                    );
                }}
            />
        </div>
    );
};
